import 'rxjs/add/operator/debounceTime';
import {Component, ViewChildren} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TAction} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {SuperTabComponent} from 'ionic2-super-tabs';

import {LogadoService} from '../../../providers/logado-service';
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileService} from "../../../providers/profile-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {NegocioMenuPage} from "../negocio-menu/negocio-menu";
import {HotspotWorkPage} from "../hotspot-work/hotspot-work";
import {WebstorMenuPage} from "../webstor-menu/webstor-menu";
import {MessageService} from "../../../providers/message-service";
import {ProfileMenuPage} from '../profile-menu/profile-menu';
import {WebsiteOlhaPage} from '../website-olha/website-olha';

@Component({
    selector: 'page-webstor-seta',
    templateUrl: 'webstor-seta.html',
    providers: [WebstorService, ProfileService]
})

export class WebstorSetaPage {

    config: any;
    logado: any;
    rootile: any;

    youself: boolean;

    webstorErro: any;
    webstorRoot: any;
    webstorNick: string;

    page1: any;
    page2: any;
    page3: any;

    akkjson = (window as any).handappMainInstance.appjson;

    fixHeaderInterval = 0;

    @ViewChildren(SuperTabComponent) superTab: SuperTabComponent[] = [];

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, public webstorService: WebstorService, public messageService: MessageService,
                public logadoService: LogadoService, public profileService: ProfileService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.youself = (this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID);


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Webstor Seta', '/webstor-seta');


        this.messageService.get('webstor.nick').subscribe(data => this.webstorNick = data);

        this.webstorLoad();

        this.messageService.get('webstor.zera').subscribe(
            data => {
                this.webstorRoot = null;
                this.webstorLoad();
            });

            //console.log(navCtrl.parent.root.name == 'CheckinMenuPage');
    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    ionViewDidLeave() {

        clearInterval(this.fixHeaderInterval);

    }

    onTabSelect(event) {

        this.util.websterPage = event.index;

        //#Nao sei se funciona...
        //this.superTabsCtrl.showToolbar(false);

    }

    webstorTopo(texto?): string {

        if (!this.webstorRoot) return 'CorMilk';

        let monitorAuth = this.akkjson.hotwork;
        if (this.util.websterPage == 1) return (texto ? 'CorMilk' : 'CorMenu');
        if (!monitorAuth)               return (texto ? 'CorMilk' : 'CorRoxa');
        if ( monitorAuth)               return (texto ? this.config.negative(monitorAuth.Hotspot.Branded.BrandedCora) : monitorAuth.Hotspot.Branded.BrandedCora);

    }

    /** ************************************************ WEBSTOR ************************************************** **/
    /** ************************************************ etapa-4 ************************************************** **/

    webstorLoad() {

        let onData = (data) => {
            let team = this.rootile.Profile.ProfileTeam;
            this.page1 = HotspotWorkPage;
            this.page2 = NegocioMenuPage;
            this.page3 = (!team ? WebsiteOlhaPage : ProfileMenuPage);
            this.util.websterPage = team ? 1 : 0;
            this.webstorRoot = data;

            //#GAMBI-SUPER-TABS
            this.superFix();

            //let bool = (this.util.jsCount(data.Negocios, ['Brandeds', 'BrandedID']) == 1);
            this.webstorNick = 'ADM';//(bool ? data.Negocios[0].Brandeds[0].BrandedNick : 'ADM');
        };

        let onErro = (erro) => {
            let sorry = '<b>Desculpe</b>, parece que meus sensores estão desconectados.';
            this.webstorErro = (erro.Result == this.config.request.timeoutErroPadrao.Result ? sorry : erro.Result);
        };

        this.webstorService.webstor(TAction.acAuth, this.rootile.Profile.ProfileID)
            .subscribe(
                data => onData(data),
                erro => onErro(erro)
            )

    }

    settingOpen() {

        this.navCtrl.push(WebstorMenuPage, null, {animation: 'md-transition'});

    }

    warning() {

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'liacheckin')};
        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    superFix() {

        if (this.util.nativeApp()) return;

        this.fixHeaderInterval = setInterval(() => {

            this.superTab.forEach(tab => {

                const array = tab._elementRef.nativeElement.childNodes;

                for (let i in array) {

                    let item = array[i];

                    //let beel = (item.children[0] && item.children[0].className == 'HEADER');
                    let bool = (item.tagName != 'DIV' && typeof item != 'function' && typeof item != 'number');
                    if  (!bool || !item.children[1] || !item.children[1].children[1]) continue;

                    let header = item.children[0];

                    //console.log(header.tagName);
                    let scroll = item.children[1].children[1];
                    scroll.style.setProperty('margin-top', 0 + 'px');
                    if (header.tagName != 'ION-HEADER') scroll.style.setProperty('top', 0);
                    if (header.tagName == 'ION-HEADER') scroll.style.setProperty('top', header.offsetHeight + 'px');

                }

            });

        }, 100);

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/webstor-seta/webstor-seta.ts